module.exports = __webpack_public_path__ + "img/epr@2x.24934e46.jpeg";